import React, { useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Lottie from "lottie-react";
import money from "../assets/whyus/money";
import AOS from "aos";

const Container = tw.div`relative bg-slate-50`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-12`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 md:h-auto relative`;
const TextColumn = styled(Column)(tw`md:w-7/12 mt-10 md:mt-0`);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;
const Heading = tw.h2`mt-4 font-black text-left text-2xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight px-2`;
const Description = tw.div`px-2 py-6 text-center md:text-left text-base md:text-base lg:text-lg font-light leading-relaxed text-gray-500 mt-4`;
const Statistics = tw.div`grid grid-cols-3 gap-10 items-center sm:block text-center md:text-left mt-4 px-2`;

const Statistic = tw.div`text-center sm:inline-block sm:mr-12 last:mr-0 py-2`;
const Value = tw.div`font-semibold text-lg sm:text-xl lg:text-2xl text-[#ed1c24]`;
const Key = tw.div`font-light text-gray-500`;
const HighlightedText = tw.span`text-[#ed1c24]`;
const heading1 = "成为百家客户的";
const heading2 = "5大好处";
const description1 =
  "买房前不知该如何出价？— 您可以得到百家信贷为您量身定制的详细房屋市场估价报告。";
const description2 =
  "对未来个人理财没有头绪 — 您可以得到百家信贷顾问为您提供专业房产理财建议。";
const description3 =
  "银行是否能给喜欢的房子放款？— 您可以得到百家信贷顾问的专业审查服务。";
const description4 =
  "贷款到期忘记了怎么办？— 您可以享受百家信贷专人专项的房屋贷款再固定服务。";
const description5 =
  "我还有其他金融财富目标？— 您可以优先得到百家信贷提供的其他金融服务并取得折扣。";
let statistics = null;
const defaultStatistics = [
  {
    key: "满意客户",
    value: "3500+",
  },
  {
    key: "贷款项目",
    value: "10800+",
  },
  {
    key: "荣获奖项",
    value: "50+",
  },
];

const WhyUsCN = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  if (!statistics) statistics = defaultStatistics;

  return (
    <Container>
      <TwoColumn data-aos="fade-up">
        <ImageColumn>
          <Lottie
            animationData={money}
            loop={true}
            mheight={500}
            mwidth={300}
          />
        </ImageColumn>
        <TextColumn>
          <TextContent>
            <Heading>
              {heading1}
              <HighlightedText>{heading2}</HighlightedText>
            </Heading>
            <Description>
              {description1}
              <br />
              <p className="mt-2"></p>
              {description2}
              <br />
              <p className="mt-2"></p>
              {description3}
              <br />
              <p className="mt-2"></p>
              {description4}
              <br />
              <p className="mt-2"></p>
              {description5}
            </Description>
            <Statistics>
              {statistics.map((statistic, index) => (
                <Statistic key={index}>
                  <Value>{statistic.value}</Value>
                  <Key>{statistic.key}</Key>
                </Statistic>
              ))}
            </Statistics>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};

export default WhyUsCN;
